export const mensajesInbox = {
  title: "Messaggi",

  noAccess: {
    description:
      "Per accedere alla casella dei messaggi devi avere un tuo numero WhatsApp Business collegato dalle impostazioni del tuo account.",
    connectButton: "Collega WhatsApp",
  },

  search: {
    placeholder: "Cerca per telefono o ospite...",
  },

  filters: {
    allProperties: "Tutte le strutture",
    searchProperty: "Cerca struttura...",
    filterTitle: "Filtra messaggi",
    clearAll: "Rimuovi filtri",
    removeOne: "Rimuovi «{filtro}»",
    someActive: "{count} filtri",
  },

  tabs: {
    all: "Tutte",
    unread: "Non lette",
    pinned: "Fissate",
    archived: "Archiviate",
    noReservation: "Senza prenotazione",
    otaBooking: "Booking.com",
    otaAirbnb: "Airbnb",
    otaExpedia: "Expedia",
    otaOther: "Altra OTA",
    unpaid: "Non pagate",
    paid: "Pagate",
    arrivingSoon: "In arrivo",
  },

  filterGroups: {
    chat: "Conversazione",
    origin: "Origine",
    reservation: "Prenotazione",
  },

  list: {
    empty: "Nessuna conversazione",
    noMessages: "Nessun messaggio",
  },

  channels: {
    web: "Web",
    webConcierge: "Concierge web · Portale del soggiorno",
    otaMessage: "Messaggio {provider}",
  },

  chat: {
    placeholderSelect: "Seleziona una conversazione per iniziare",
    loading: "Caricamento conversazione...",
    dropToAttach: "Trascina qui per allegare i file",
    emptyThread: "Ancora nessun messaggio in questa conversazione",
    notSent: "Non inviato",
    sending: "Invio in corso...",
  },

  sender: {
    guest: "Ospite",
    you: "Tu",
    aiAgent: "Agente IA",
  },

  media: {
    document: "Documento",
    sharedLocation: "Posizione condivisa",
    attachment: "Allegato",
  },

  preview: {
    attachmentSent: "Allegato inviato",
    messageSent: "Messaggio inviato",
    attachmentReceived: "Allegato ricevuto",
    newMessage: "Nuovo messaggio",
  },

  mode: {
    aiAgent: "Agente IA",
    manual: "Manuale",
  },

  automation: {
    disabledNotice:
      "L’Agente IA non è attivo in questa struttura: non risponderà, i messaggi li scrivi tu.",
    aiActiveBanner:
      "L’agente IA sta rispondendo automaticamente a questo ospite.",
  },

  faq: {
    title: "Domande frequenti",
  },

  composer: {
    placeholder: "Scrivi un messaggio o usa / per inserire una risposta...",
    hint: "Invio per inviare · Maiusc+Invio per andare a capo",
  },

  actions: {
    newConversation: "Nuova conversazione",
    options: "Opzioni",
    attachFile: "Allega file",
  },

  alt: {
    flag: "Bandiera",
    sentImage: "Immagine inviata",
  },

  common: {
    file: "file",
    notAvailable: "Non disponibile",
  },

  nights: "{count} notte | {count} notti",

  arrival: {
    pending: "Data da definire",
    today: "Arriva oggi",
    tomorrow: "Arriva domani",
    yesterday: "Arrivato ieri",
    inDays: "Tra {count} giorni",
    daysAgo: "Arrivato {count} giorni fa",
  },

  reservationStatus: {
    booked: "Confermata",
    cancelled: "Annullata",
    pending: "In attesa",
    checked_in: "Check-in effettuato",
    checked_out: "Check-out effettuato",
  },

  reservationPanel: {
    title: "Prenotazione collegata",
    stayEnded: "L’ospite non è più in soggiorno",
    checkIn: "Check-in",
    checkOut: "Check-out",
    room: "Camera",
    reservation: "Prenotazione",
    phone: "Telefono",
    viewReservation: "Vedi prenotazione",
    noReservationTitle: "Nessuna prenotazione collegata",
    noReservationOta:
      "Questa conversazione proviene da {channel} tramite Channex e non è ancora collegata a una prenotazione locale.",
    noReservationWhatsapp:
      "Questo contatto ha scritto al WhatsApp collegato ma non è ancora collegato a una prenotazione.",
    assignReservation: "Assegna prenotazione",
    createReservation: "Crea prenotazione",
    assignExisting: "Assegna prenotazione esistente",
    searchPlaceholder: "Cerca per nome o codice...",
    noReservationsFound: "Nessuna prenotazione trovata",
    placeholderContext: "Seleziona una conversazione per vedere il contesto",
    propertyUnavailable: "Struttura non disponibile",
  },

  contextMenu: {
    pin: "Fissa conversazione",
    unpin: "Rimuovi dai fissati",
    archive: "Archivia conversazione",
    unarchive: "Ripristina dall’archivio",
  },

  waStatus: {
    read: "Letto",
    delivered: "Consegnato",
    queued: "In coda",
    failed: "Non riuscito",
    sent: "Inviato",
  },

  waFailTitle: {
    noWhatsapp: "Nessun WhatsApp",
    invalidNumber: "Numero non valido",
    notSent: "Non inviato",
  },

  waErrors: {
    generic: "Impossibile inviare questo messaggio tramite WhatsApp.",
  },

  waErrorShort: {
    e131042: "problema di pagamento sull’account WhatsApp",
    e131026: "il numero non può ricevere messaggi WhatsApp",
    e131053: "WhatsApp non è riuscito a scaricare il file",
    e132000: "dati mancanti nel modello",
    e131009: "il messaggio non soddisfa i requisiti di WhatsApp",
  },

  toasts: {
    aiActiveSwitchManual:
      "L’agente IA è attivo. Passa alla modalità manuale per rispondere.",
    pinned: "Conversazione fissata",
    unpinned: "Conversazione rimossa dai fissati",
    archived: "Conversazione archiviata",
    unarchived: "Conversazione ripristinata",
    reservationAssigned: "Prenotazione assegnata: {name}",
    reservationUnassigned: "Assegnazione annullata",
    selectPropertyToCreate:
      "Seleziona una struttura per creare la prenotazione da questa chat.",
    userNotResolved: "Impossibile identificare l’utente del pannello.",
    aiNotEnabledConfig:
      "Questa struttura non ha l’Agente IA abilitato. Abilitalo dalle impostazioni dell’alloggio.",
    aiEnabledForChat: "Agente IA abilitato per questa conversazione",
    manualEnabledForChat: "Modalità manuale abilitata per questa conversazione",
    templateSent: "Modello inviato con successo.",
  },

  errors: {
    inboxNotActive:
      "La casella dei messaggi non è attiva per questo account, oppure il WhatsApp Business deve ancora essere collegato.",
    openConversation: "Impossibile aprire la conversazione",
    sendMessage: "Impossibile inviare il messaggio. Controlla la tua connessione WhatsApp.",
    pin: "Errore nel fissare la conversazione",
    archive: "Errore nell’archiviazione",
    loadReservations: "Errore nel caricamento delle prenotazioni",
    assignReservation: "Errore nell’assegnazione della prenotazione",
    unassignReservation: "Errore nell’annullamento dell’assegnazione",
    updateMode: "Impossibile aggiornare la modalità per questa conversazione",
    reactivationTemplate: "Impossibile inviare il modello di riattivazione.",
  },
};
